import { baseRequest } from '@thrivadev/thriva-request';
import { SHOP_SUBSCRIPTIONS_API_PATH } from './helpers';
const requestOptions = {
    method: 'GET'
};
/**
 * ```ts
 * import { getShopSubscriptions } from "@thrivadev/thriva-shop";
 * //
 * const { data: subscription, included }: Subscription = await getShopSubscriptions({
 *    filters: [{ filterAttribute: ShopSubscriptionFilters.State, filterValue: 'active' }],
 *    includes: [ShopSubscriptionInclude.Variant]
 * });
 * ```
 * Returns subscriptions
 *
 * @param apiOptions - The filters to use for this request.
 * @returns A Promise<Subscription>
 */
export function getShopSubscriptions(apiOptions) {
    return baseRequest(SHOP_SUBSCRIPTIONS_API_PATH, requestOptions, apiOptions);
}
/**
 * ```ts
 * import { getShopSubscription } from "@thrivadev/thriva-shop";
 * //
 * const { data: subscription, included }: Subscription = await getShopSubscription(
 *    'SUBTWUQNFV9N6OEF',
 *    {
 *      filters: [{ filterAttribute: ShopSubscriptionFilters.State, filterValue: 'active' }],
 *      includes: [ShopSubscriptionInclude.Variant]
 *    }
 * );
 * ```
 * Returns a subscription.
 *
 * @param subscriptionId - The id of the subscription to load.
 * @param apiOptions - The filters to use for this request.
 * @returns A Promise<Subscription>
 */
export function getShopSubscription(subscriptionId, apiOptions) {
    return baseRequest(`${SHOP_SUBSCRIPTIONS_API_PATH}/${subscriptionId}`, requestOptions, apiOptions);
}
//# sourceMappingURL=get.js.map